<template>
    <div class="p-grid crud-demo">
        <h1 class="p-mx-auto">Trainings</h1>
        <div class="p-col-12">
            <Toast/>
            <TrainingDataTable :trainings="trainings"
                               :paginator="true"
                               :filter="true"
                               :admin-mode="true"
                               :showStaff="true"
                               :loading="loading"
                               @create-training="createTraining"
                               @edit-training="editTraining"
                               @confirm-delete-training="confirmDeleteTraining"
                               @confirm-delete-selected-trainings="confirmDeleteSelectedTrainings"
                               @toggle-trainings="toggleTrainings"
                               @show-file-dialog="showFileDialog"/>
            <TrainingDialog ref="trainingDialog" @updated="onItemsUpdated"/>
            <FileDialog ref="fileDialog" @updated="onItemsUpdated"/>
        </div>
    </div>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator'
import Toast from 'primevue/toast';
import TrainingService from "@/service/TrainingService";
import TrainingDialog from "../components/dialog/TrainingDialog";
import TrainingDataTable from "../components/datatable/TrainingDataTable";
import FileDialog from "../components/dialog/FileDialog";
import store from "../store";

/**
 * Class-component
 */
@Component({
    components: {
        TrainingDataTable,
        TrainingDialog,
        FileDialog,
        Toast: Vue.extend(Toast),
    }
})
export default class Trainings extends Vue {
    trainingService = new TrainingService();
    trainings = [];
    trainingDialog = false;
    loading = false;
    toastSuccess = {
        severity: 'success',
        summary: 'Successful',
        detail: '',
        life: 3000
    };
    toastError = {
        severity: 'error',
        summary: 'Error',
        detail: '',
        life: 3000
    };

    async mounted() {
        try {
            this.loading = true;
            this.trainings = await this.trainingService.getTrainings();
            this.loading = false;
        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.trainingService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }

    // listen to items updated
    async onItemsUpdated() {
        this.trainings = await this.trainingService.getTrainings();
    }

    // Training Dialog
    createTraining() {
        this.$refs.trainingDialog.createTraining = true;
        this.$refs.trainingDialog.training = {};
        this.$refs.trainingDialog.trainingDialog = true;
    }

    async editTraining(training) {
        this.$refs.trainingDialog.createTraining = false;
        this.$refs.trainingDialog.training = {...training};
        this.$refs.trainingDialog.trainingDialog = true;
    }

    confirmDeleteTraining(training) {
        this.$refs.trainingDialog.training = training;
        this.$refs.trainingDialog.deleteTrainingDialog = true;
    }

    confirmDeleteSelectedTrainings(selectedTrainings) {
        this.$refs.trainingDialog.selectedTrainings = selectedTrainings;
        this.$refs.trainingDialog.deleteTrainingsDialog = true;
    }

    toggleTrainings(selectedTrainings, status) {
        this.$refs.trainingDialog.selectedTrainings = selectedTrainings;
        this.$refs.trainingDialog.verifyTrainings = status;
        this.$refs.trainingDialog.toggleTrainingsDialog = true;
    }

    // File Dialog
    async showFileDialog(record) {
        try {
            this.loading = true;
            record = await store.dispatch('jv/get', [`${record._jv.type}/${record._jv.id}`, {params: {include: 'files', 'fields[files]': 'name,created-at'}}]);
            this.$refs.fileDialog.record = record;
            this.$refs.fileDialog.files = Object.values(record.files);
            this.$refs.fileDialog.fileDialog = true;
            this.loading = false;
        } catch (e) {
            this.toastError.detail = e.message
            this.toastError.life = null
            this.$toast.add(this.toastError);
            this.staffService.logError(e).forEach(err => {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Details',
                    detail: err,
                    life: null
                });
            })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
